var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlexLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 390,
    viewBox: "0 0 327 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.51 129.971H242.992C305.936 129.971 346.765 196.658 317.164 252.117C296.069 292.605 252.519 371.2 243.673 386.851C242.652 388.552 240.951 389.573 238.909 389.573H113.361C109.279 389.573 106.557 385.49 108.598 381.747C122.208 356.57 164.397 278.315 174.264 259.942H84.7814C22.858 259.942 -18.3108 194.276 9.929 139.157C31.0238 97.9886 74.234 18.7131 83.0802 2.7219C84.1009 1.02071 85.8021 0 87.8435 0H214.752C218.835 0 221.557 4.08286 219.516 7.82548C195.019 53.4174 153.51 129.971 153.51 129.971ZM165.418 213.329L192.977 197.338C194.678 196.318 194.678 193.596 192.977 192.575L165.418 176.584L137.858 160.593C136.157 159.572 133.776 160.933 133.776 162.974V194.957V226.939C133.776 228.98 135.817 230.341 137.858 229.321L165.418 213.329Z",
    fill: "#545759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlexLogoIcon);
export default __webpack_public_path__ + "static/media/slex-logo-icon.846e943b0b3e572a0e43595f55df097b.svg";
export { ForwardRef as ReactComponent };